export const isDisabled = (fieldId, formType) => {
    if (!formType || !formType.disableFields) {
        return;
    }

    return formType.disableFields.includes(fieldId);
};



// WEBPACK FOOTER //
// ./src/utils/isDisabled.js